// extracted by mini-css-extract-plugin
export default {"fullScreen":"index_fullScreen_-D8nF","wrap":"index_wrap_x-FrG","icon":"index_icon_fqW1X","text":"index_text_b6Fro","btn":"index_btn_QKsj0"};